export interface SpecialPick {
  movieId: string;
  reason: string;
}

export interface Special {
  id: string;
  title: string;
  intro: string;
  cover: string;
  date: string;
  essayIds: string[];
  picks: SpecialPick[];
  relatedIds: string[];
}

export const specials: Special[] = [
  {
    id: 'morality-on-screen',
    title: '道德困境特辑：当银幕把我们逼到墙角',
    intro: '好的伦理片从不告诉你什么是对，而是让你亲身经历一次“无法两全”。本期专题精选近年最值得反复咀嚼的五部美国伦理电影，从良知、忠诚到身份认同，逐一拆解那些让人坐立难安的抉择时刻。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20cinematic%20banner%20of%20crossed%20light%20beams%20over%20a%20dark%20stage%2C%20deep%20indigo%20and%20warm%20amber%20accents%2C%20dramatic%20restrained%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=special-cover-01&orientation=landscape',
    date: '2026-09-30',
    essayIds: ['review-silent', 'review-testimony', 'review-boundary'],
    picks: [
      { movieId: 'silent-confession', reason: '把“沉默”拍成一种共谋，最克制也最有力。' },
      { movieId: 'testimony-long-night', reason: '关于勇气的成本，一部会让你重新定义“作证”的电影。' },
      { movieId: 'beyond-the-line', reason: '2024 年最具讨论度，收尾克制而余震不断。' },
      { movieId: 'edge-of-lies', reason: '一个被生活逼迫的人，是否还有选择善良的余地。' },
    ],
    relatedIds: ['family-portraits'],
  },
  {
    id: 'family-portraits',
    title: '家庭肖像：血缘、记忆与那些说不出口的话',
    intro: '家庭是最小的伦理现场。这一期我们把镜头对准餐桌、走廊与旧照片，看看美国伦理电影如何用日常空间，讲述最深刻的爱与伤害。血缘意味着责任还是枷锁？记忆该被完整保留还是温柔篡改？',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20cinematic%20banner%20of%20an%20empty%20family%20dining%20table%20under%20warm%20fading%20lamplight%2C%20sepia%20and%20muted%20amber%20tones%2C%20nostalgic%20tender%20mood%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=special-cover-02&orientation=landscape',
    date: '2026-08-20',
    essayIds: ['review-ash', 'review-coast'],
    picks: [
      { movieId: 'ash-and-vow', reason: '承认“原谅并非必选项”，分寸拿捏得极好。' },
      { movieId: 'the-road-back', reason: '回家的路很长，和解比想象中更远。' },
      { movieId: 'beneath-still-water', reason: '安静却后劲十足，关于记忆的选择性遗忘。' },
      { movieId: 'the-last-letter', reason: '看完会想给家人打个电话。' },
    ],
    relatedIds: ['morality-on-screen'],
  },
];

export const getSpecialById = (id: string): Special | undefined =>
  specials.find((s) => s.id === id);